/**
 * Shared look for every numbered choice tile in the pulse — the 1–5 rating
 * scale, the 1–3 ranking buttons and the numbered single-select options.
 */
export function numberTileClass(active: boolean, size: string): string {
  return [
    'flex shrink-0 items-center justify-center rounded-xl border font-display font-bold tabular-nums',
    'transition-colors duration-150 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue',
    active ? 'border-blue bg-blue text-paper' : 'border-line bg-mist text-navy2',
    size,
  ].join(' ')
}
